import React from "react"
import PropTypes from "prop-types"

import FilterRow from "./FilterRow/index.jsx"

export default function VenueCategoriesChooser(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { categories, onSelect, onAllCategoriesSelected } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const allCategoriesSelected = !categories.some((element) => element.selected)

  // -------------------------------------

  return (
    <div>
      <FilterRow
        key="all"
        name="all"
        label={I18n.t("pages.locations.venues.cuisines.all")}
        selected={allCategoriesSelected}
        onSelect={() => onAllCategoriesSelected()}
      />

      <hr />
      {categories.map((category, index) => {
        return (
          <FilterRow
            key={index}
            name={category.id}
            label={category.name}
            selected={category.selected}
            onSelect={() => onSelect(category.id)}
          />
        )
      })}
    </div>
  )
}

VenueCategoriesChooser.propTypes = {
  categories: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onAllCategoriesSelected: PropTypes.func.isRequired,
}
